import Button, { ButtonProps } from '@material-ui/core/Button';
import styled from 'styled-components';

export type BasicButtonProps = ButtonProps;

const BasicButton = styled(Button)<{ disableMarginLeft?: boolean; backgroundcolor?: string }>`
  color: var(--text);
  text-transform: none;
  height: 28px;
  max-height: 28px;
  border-radius: 2px;
  display: flex;
  align-items: center;
  &:disabled {
    background-color: ${props => props.backgroundcolor || 'var(--grey)'};
    color: var(--subtitle);
  }
` as React.ComponentType<BasicButtonProps>;

export default BasicButton;
